export const getters = {
  getTeams(state) {
    return state.teams;
  },
  getSelectedTeam(state) {
    return state.selectedTeam;
  },
}
